import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'sss-leading-bullets',
  templateUrl: './leading-bullets.component.html',
  styleUrls: ['./leading-bullets.component.scss']
})
export class LeadingBulletsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
